module.exports = __webpack_public_path__ + "static/img/playerHead.58b09396.png";